<shared-forms-input type="select" [defaultSelected]="1" [selectOptions]="periods" [disabled]="true" [compact]="true">
</shared-forms-input>
<shared-forms-input type="select" [defaultSelected]="1" [selectOptions]="pickups" [disabled]="true" [compact]="true">
</shared-forms-input>